import { Button, Flex, Text } from '@joinrepublic/dls-ui-kit';

import { ICryptoAssetsErrorProps } from './types';

/**
 * Failure state for the crypto rail.
 *
 * Deliberately not `QueryError` from `@r-client/republic/feature/errors`: that
 * component types its `queries` as `BaseQueryModel[]` and calls `refetch()` on
 * them, and a react-query result is not assignable. Casting would compile and
 * then break the day someone adds another model call there.
 *
 * The copy matches `QueryError`'s so the page reads the same whichever section
 * fails. The error itself is already reported to Rollbar by `createQueryClient`
 * — reporting it here too would double-count.
 */
export const CryptoAssetsError = ({
  onRetry,
  isRetrying = false,
}: ICryptoAssetsErrorProps) => (
  <Flex direction="column" align="center" gap="2">
    <Text size="body-md" fontWeight="semibold">
      Something went wrong
    </Text>
    <Button
      variant="neutral-secondary"
      size="sm"
      onClick={onRetry}
      isLoading={isRetrying}
    >
      Try Again
    </Button>
  </Flex>
);
